module.exports = __webpack_public_path__ + "static/media/rm_06-04.a00f389f.png";